module.exports = __webpack_public_path__ + "static/pielegniarstwo-image-2-96c137e021cc87fbc30a75cfc51643e3.png";